import { Avatar, Box, Flex, } from "@chakra-ui/react";
import { combineDsrActiveTeamMembersFromAllOrgs } from '../../../profile/helpers/user-helper';
import { getThisUserIdToken } from '../../../global/helpers/global-helpers';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from "../../../global/components/helper-components/components/LaunchdeckModal";
import { RiExchange2Fill } from "react-icons/ri";

export default function PickDsrContactPersonModal({
  handleCloseModal,
  dsrTeamMembers,
  mainContactUserId,
  handleAssignMainContact
}) {

  const handleClickSelectButton = (userId) => {
    handleAssignMainContact('other-team-member', userId)
    handleCloseModal()
  }

  function renderSellerTeam() {
    const teamToRender = dsrTeamMembers["sellerTeam"];
    const combinedTeamMembersArray = combineDsrActiveTeamMembersFromAllOrgs(teamToRender)

    const renderTeam = Array.isArray(combinedTeamMembersArray) && combinedTeamMembersArray?.map((member, memberIndex) => {
      const { userId, email, memberName, memberProfilePicSrc, memberOrgName, memberOrgTitle } = member || {};
      const supplementaryUserInfo = (memberOrgTitle && memberOrgName) ? `${memberOrgTitle}, ${memberOrgName}` : memberOrgName ? memberOrgName : email;

      return (
        <Flex key={`seller_team_member_${memberIndex}`} justify='space-between' align='center' w='100%' my='1em' px='1em'>
          <Flex align='center' justify='flex-start'>
            <Avatar h='4.2em' w='4.2em' name={memberName} bg='gray.100' color='gray.700' src={memberProfilePicSrc ? memberProfilePicSrc : ""} />
            <Box ml='1em'>
              <Flex align='baseline' justify='flex-start'>
                <Box fontSize='0.875em'>{memberName || '- -'}</Box>
              </Flex>
              <Box fontSize='0.7em' color='gray.500'>{supplementaryUserInfo}</Box>
            </Box>
          </Flex>

          {(userId !== mainContactUserId) &&
            <LaunchdeckButton 
              label='Select' 
              fontSize='0.8em' py='0.4em' 
              bg='brand.50' color='brand.600'
              transition="all 0.3s ease-in-out"
              hover={true}
              onClick={() => handleClickSelectButton(userId)} />
          }
        </Flex>
      )
    })


    if (!renderTeam) {
      return null
    }

    if (renderTeam.length === 0) {
      // TODO Review: Send Slack notification on Frontend error
      return null
    } else if (renderTeam.length === 1) {
      if (combinedTeamMembersArray[0].userId === getThisUserIdToken()) {
        return (
          <Box>
            <Box justify='flex-start' bg='gray.100' rounded='0.5em' p='0.5em 1em' align='flex-start' mx='1em' mb='2em' fontSize='0.75em' color='brandDark.500'>
              There is no other eligible person in your team to act as the main contact person
            </Box>
            <Box mt='0.5em'>{renderTeam}</Box>
          </Box>
        )
      }
    } else {
      return (
        <Box>
          <Box mt='0.5em'>{renderTeam}</Box>
        </Box>
      );
    }
  }


  function renderTeamManagementContent() {

    return (
      <Box mb='1em' w='100%'>
        <Box mb='2em'>
          {renderSellerTeam()}
        </Box>
      </Box>
    )
  }

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={RiExchange2Fill} color='brand.500' boxSize="1.6em" />
        <Box color='white'>Change main contact person</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      <Box w='100%' p='1em' height='70vh' overflowY='auto'      >
        {renderTeamManagementContent()}
      </Box>
    </LaunchdeckModal>
  )
}
